<template>
  <div>
    <SelectInput class='sm:hidden' v-model='model' :options='options' />
    <div class="hidden sm:block">
      <div class="border-b border-gray-200">
        <nav class="-mb-px flex space-x-8" aria-label="props.tabs">
          <button v-for="tab in props.tabs" :key="tab.key" :class="[model === tab.key ? 'border-jananavy-900 text-jananavy-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700', 'whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium']" :aria-current="model === tab.key ? 'page' : undefined" @click='model = tab.key'>{{ tab.name }}</button>
        </nav>
      </div>
    </div>
  </div>
</template>

<script setup>

import { computed } from 'vue';

import SelectInput from '@/components/inputs/select-input.vue';

const props = defineProps({
  tabs: Array
});

const model = defineModel();

const options = computed(() => {
  return props.tabs.map(tab => ({label: tab.name, value: tab.key}));
});

</script>
